import React from 'react';
import {
  BRICK_SIZE_OTHER,
  FACTORY_BRICK_SIZE_OPTIONS,
  brickSizeSelectValue,
  isPresetBrickSize,
} from '../constants/factoryBrickSizes';

/**
 * Preset size dropdown + optional custom size input.
 */
export default function BrickSizeField({ value, onChange, disabled = false, className = '' }) {
  const selectVal = brickSizeSelectValue(value);
  const showCustom = selectVal === BRICK_SIZE_OTHER;

  return (
    <span className={`brick-size-field${className ? ` ${className}` : ''}`}>
      <select
        className="brick-size-field__select"
        value={selectVal}
        onChange={(e) => {
          const next = e.target.value;
          if (next === BRICK_SIZE_OTHER) {
            onChange(isPresetBrickSize(value) ? '' : value);
          } else {
            onChange(next);
          }
        }}
        disabled={disabled}
        aria-label="Brick size"
      >
        <option value="">Select size…</option>
        {FACTORY_BRICK_SIZE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
        <option value={BRICK_SIZE_OTHER}>Other (custom size)…</option>
      </select>
      {showCustom ? (
        <input
          className="brick-size-field__custom"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="e.g. 230×110×75 mm"
          disabled={disabled}
          aria-label="Custom brick size"
        />
      ) : null}
    </span>
  );
}
